import React from "react";
import styled from "styled-components";

const Button = styled.button.attrs(props => ({
  tabIndex: props.tabIndex,
  alt: props.alt,
  title: props.title,
}))`
  width: ${({ width }) => width || null};
  font-size: ${({ textSize }) => textSize || "16px"};
  height: ${({ height }) => height || "auto"};
  background-color: ${({ background, theme }) => background || theme.primaryColor};
  border: ${({ border }) => border || "none"};
  border-radius: ${({ borderRadius }) => borderRadius || "3px"};
  margin: ${({ margin }) => margin || "0"};
  padding: ${({ padding }) => padding || ".7rem 1rem"};
  color: ${({ color }) => color || "#fff"};
  text-align: ${({ align }) => align || ""};
  flex: ${({ flex }) => flex || null};
  cursor: pointer;
  font-weight: 600;
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  &:hover {
    background-color: ${({ theme, hoverBackground }) => hoverBackground || theme.hoverColorGray};
  }
`;
const ButtonText = styled.span`
  vertical-align: middle;
  display: inline-block;
  margin: 0;
`;

const MainButton = ({
  onClick,
  title,
  background,
  text,
  border,
  type,
  align,
  id,
  width,
  iconAlign,
  color,
  padding,
  margin,
  height,
  typeOfIcon,
  disabled,
  flex,
  textSize,
  hoverBackground,
  Icon,
  borderRadius,
  iconSize,
  iconColor,
  iconMargin,
  style,
  tabIndex,
}) => (
  <Button
    tabIndex={tabIndex}
    id={id ? id : ""}
    title={title}
    onClick={onClick}
    flex={flex}
    disabled={disabled}
    type={type}
    hoverBackground={hoverBackground}
    width={width}
    background={background}
    height={height}
    margin={margin}
    padding={padding}
    align={align}
    textSize={textSize}
    border={border}
    color={color}
    borderRadius={borderRadius}
    style={{ ...style }}
  >
    {typeof Icon !== "undefined" ? (
      <Icon
        fontSize={typeOfIcon}
        style={{
          color: iconColor,
          display: "inline-block",
          fontSize: iconSize,
          margin: iconMargin,
          verticalAlign: iconAlign || "middle",
        }}
      />
    ) : (
      ""
    )}
    <ButtonText>{text}</ButtonText>
  </Button>
);

export default MainButton;
